import { useState } from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';

import store from "../../store/index";
import { toggleTheme } from "../../store/actions/Theme";

import StyledSwitch from '../styled/Switch';
import { Tooltip } from '@mui/material';

export const ThemeToggle = () => {
    const currentTheme = useSelector((state) => state.theme.currentTheme);

    const [checked, setChecked] = useState(currentTheme === 'Dark');

    const { t } = useTranslation();

    const handleThemeChange = function(event) {
        if (event.target.checked) {
            store.dispatch(toggleTheme('Dark'));
            localStorage.setItem('currentTheme', 'Dark');
            setChecked(true);
        } else {
            store.dispatch(toggleTheme('Light'));
            localStorage.setItem('currentTheme', 'Light');
            setChecked(false);
        }
    };

    return (
        <Tooltip title={t('Change theme')} placement="right">
            <StyledSwitch checked={checked} onChange={handleThemeChange} />
        </Tooltip>
    );
};
